import { HttpAxiosRequest } from 'src/http/httpAxiosBase'

const getEndpoint = (url = '') => `objetos-seguridad${url}`

export const HttpObjetosSeguridadABM = {
    getObjetos: () => {
        return HttpAxiosRequest.get(getEndpoint())
    },

    postObjeto: (dto: ObjetoSeguridadPostDTO) => {
        return HttpAxiosRequest.post(getEndpoint(), dto)
    },

    putObjeto: (id: number, dto: ObjetoSeguridadPostDTO) => {
        return HttpAxiosRequest.put(getEndpoint(`/${id}`), dto)
    },

    inactivar: (id: number) => {
        return HttpAxiosRequest.delete(getEndpoint(`/${id}`))
    },

    // Selectores
    getTipos: (): Promise<{ id: number; descripcion: string }[]> => {
        return HttpAxiosRequest.get(getEndpoint('/tipos'))
    },

    getPermisoTipos: (): Promise<{ id: number; descripcion: string }[]> => {
        return HttpAxiosRequest.get(getEndpoint('/permisos-tipos'))
    },

    // Permisos por perfil
    getPermisosPorPerfil: (idPerfil: number) => {
        return HttpAxiosRequest.get(getEndpoint(`/permisos/perfil/${idPerfil}`))
    },

    actualizarPermisosPorPerfil: (idPerfil: number, permisos: PerfilPermisoUpdateDTO[]) => {
        return HttpAxiosRequest.post(getEndpoint(`/permisos/perfil/${idPerfil}`), permisos)
    },

    // Permisos por objeto
    getPermisosPorObjeto: (idObjeto: number) => {
        return HttpAxiosRequest.get(getEndpoint(`/permisos/objeto/${idObjeto}`))
    },

    actualizarPermisosPorObjeto: (idObjeto: number, perfiles: PerfilPermisoPerfilUpdateDTO[]) => {
        return HttpAxiosRequest.post(getEndpoint(`/permisos/objeto/${idObjeto}`), perfiles)
    }
}

export type ObjetoSeguridadPostDTO = {
    codigo: string
    descripcion: string
    sinCodTipoObjetoSeguridad: number
    codLink: string | null
    codRuta: string | null
    observaciones: string
}

export type ObjetoSeguridadViewDTO = {
    id: number
    codigo: string
    descripcion: string
    sinCodTipoObjetoSeguridad: number
    descTipoObjetoSeguridad: string
    codLink: string | null
    codRuta: string | null
    observaciones: string
    bitActivo: boolean
}

export type PerfilPermisoViewDTO = {
    intIdPerfilObjetoSeguridad: number
    intIdObjetoSeguridad: number
    codObjetoSeguridad: string | null
    descObjetoSeguridad: string
    descComponente: string | null
    tinCodPerfilPermisoTipo: number
    descPermisoTipo: string
}

export type PerfilPermisoPorObjetoViewDTO = {
    intIdPerfilObjetoSeguridad: number
    intIdPerfil: number
    nombrePerfil: string
    tinCodPerfilPermisoTipo: number
    descPermisoTipo: string
}

export type PerfilPermisoUpdateDTO = {
    intIdObjetoSeguridad: number
    tinCodPerfilPermisoTipo: number
}

export type PerfilPermisoPerfilUpdateDTO = {
    intIdPerfil: number
    tinCodPerfilPermisoTipo: number
}
